import { useState } from 'react';

interface ShareButtonsProps {
  battleId: string;
  modelAName: string;
  modelBName: string;
  userVote: string;
}

export default function ShareButtons({
  battleId,
  modelAName,
  modelBName,
  userVote,
}: ShareButtonsProps) {
  const [copied, setCopied] = useState(false);

  const shareUrl = `https://videoaiarena.com/battle/${battleId}`;

  const getVoteText = () => {
    switch (userVote) {
      case 'model_a':
        return `I voted for ${modelAName}`;
      case 'model_b':
        return `I voted for ${modelBName}`;
      case 'tie':
        return 'I called it a tie';
      default:
        return 'I just judged a battle';
    }
  };

  const tweetText = `${getVoteText()} in a Video AI Arena battle! ${modelAName} vs ${modelBName}. Try it: ${shareUrl}`;

  const twitterIntentUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(tweetText)}`;

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = shareUrl;
      textArea.style.position = 'fixed';
      textArea.style.opacity = '0';
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <div className="flex items-center gap-3">
      {/* Twitter/X Share Button */}
      <a
        href={twitterIntentUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="btn btn-secondary text-sm flex items-center gap-2"
      >
        <svg
          className="w-4 h-4"
          viewBox="0 0 24 24"
          fill="currentColor"
          aria-hidden="true"
        >
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
        </svg>
        Share
      </a>

      {/* Copy Link Button */}
      <button
        onClick={handleCopyLink}
        className="btn btn-secondary text-sm flex items-center gap-2"
      >
        {copied ? (
          <>
            <svg
              className="w-4 h-4 text-green-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
            <span className="text-green-400">Copied!</span>
          </>
        ) : (
          <>
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
              />
            </svg>
            Copy Link
          </>
        )}
      </button>
    </div>
  );
}
